export enum WidgetState {
    ENTER_POSTCODE,
    SEARCHING_ADDRESS,
    PIN_ROOF,
    CALCULATING_QUOTE,
    QUOTATION_OVERVIEW,
}
